export default __webpack_public_path__ + "static/media/exit.dfb1ccc3.svg";